import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Ctas from '../../../Core/Ctas';

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: -15px;

  p + p {
    margin-top: 20px;
  }

  > div {
    width: 100%;
    margin: 15px;

    img {
      width: 100%;
      max-width: 295px;
    }

    h2,
    h3,
    .title_large,
    p {
      margin-bottom: 1rem;
    }

    .title_large {
      font-size: 5rem;
      padding: 1rem 0 0;
      letter-spacing: -0.5px;
      font-weight: ${themeGet('fontWeights.bold')};

      @media only screen and (max-width: ${themeGet('breakpoints.xlg')}) {
        font-size: 4rem;
        padding: 0;
      }

      @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
        font-size: 2rem;
      }

      @media only screen and (max-width: 640px) {
        font-size: 2rem;
      }
    }

    p {
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  &.column {
    flex-direction: column;

    > div {
      max-width: 100%;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    flex-direction: row;
    justify-content: space-between;

    > div:nth-child(1n) {
      max-width: 370px;
    }

    > div:nth-child(2n) {
      max-width: 820px;
    }
  }
`;

export const StyledCtas = styled(Ctas)`
  margin: 0;
`;
